import {
    Paper,
    styled,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material'
import {Colors} from 'appearance'
import tables from 'constants/tables'
import {useState} from 'react'
import {getPaginatedData} from 'store/slices/api/utils'
import {useI18n} from 'store/Store'
import SimplePagination from './RequestsPagination'

const SimpleTable = ({itemName, data, onClickRow}) => {
    const {i18n} = useI18n()
    const [page, setPage] = useState(0)

    const tableData = getPaginatedData(data, page)

    const tableName = `${itemName}s`
    const headers = tables[tableName].visibleKeys

    return (
        <Container>
            <TableContainer component={Paper}>
                <StyledTable sx={{height: '100%'}} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {headers.map((header) => (
                                <TableCell key={header} align="right">
                                    {i18n.t(`${tableName}.${header}`)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.map((row, i) => (
                            <TableRow
                                key={i}
                                sx={{
                                    '&:last-child td, &:last-child th': {
                                        border: 0,
                                    },
                                }}
                                onClick={() => onClickRow?.(row)}>
                                {headers.map((header) => (
                                    <TableCell
                                        key={`${header}-${i}`}
                                        align="right">
                                        {row[header]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </TableContainer>
            <SimplePagination
                count={data.length}
                page={page}
                onPageChange={setPage}
            />
        </Container>
    )
}

export default SimpleTable

const Container = styled('div')`
    height: 100%;
`

const StyledTable = styled(Table)`
    & th {
        padding: 8px;
    }
    & tr:not(:last-child) th {
        border-bottom: 1px solid ${Colors.TABLE_BORDERS};
    }
    & .MuiTableRow-head {
        background: ${Colors.LIGHT_BLUE};
    }
    & tr:nth-of-type(even) {
        background-color: ${Colors.TABLE_GREY_ROW};
    }
    & tbody div {
        background: ${Colors.LIGHT_BLUE};
    }
    &.MuiTable-root tr:not(:last-child) th:last-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
`
